const focusInput = (el: HTMLInputElement | undefined) => {
    el?.focus();
    setTimeout(() => el?.select(), 50);
};

const moveDown = (currentRow: HTMLTableRowElement, ind: number) => {
    let next = currentRow?.nextElementSibling?.getElementsByTagName("input")[ind] as HTMLInputElement | undefined;
    if (!next || next.type === "checkbox")
        next = currentRow?.nextElementSibling?.getElementsByTagName("input")[0] as HTMLInputElement | undefined;
    focusInput(next);
};

export const handleKeyDown = (event, opts?: { enterMovesDown?: boolean }) => {
    event.stopPropagation();
    const current = event.target;
    const currentRow = current.closest("tr")
    if (!currentRow) return
    const inputs = [...currentRow.getElementsByTagName("input")]
    const ind = inputs.indexOf(current)
    if (ind == -1)
        return
    switch (event.key) {
        case "ArrowRight":
            if (ind > 0) {
                const right = inputs[ind - 1]
                right?.focus()
                setTimeout(function () { right?.select() }, 5);
            } else {
                const prev = currentRow?.previousElementSibling?.getElementsByTagName("input")[inputs.length - 1]
                focusInput(prev);
            }
            break;
        case "ArrowUp": {
            const prev = currentRow?.previousElementSibling?.getElementsByTagName("input")[ind] ?? currentRow?.previousElementSibling?.getElementsByTagName("input")[0]
            focusInput(prev);
            break;
        }
        case "ArrowLeft":
            if (ind < inputs.length - 1) {
                const left = inputs[ind + 1]
                focusInput(left);
            } else {
                const next = currentRow?.nextElementSibling?.getElementsByTagName("input")[0]
                focusInput(next);
            }
            break;
        case "ArrowDown":
            moveDown(currentRow, ind);
            break;
        case "Enter":
            if (opts?.enterMovesDown) {
                event.preventDefault();
                moveDown(currentRow, ind);
            }
            break;
        default: break;
    }
};
